<div *nfLoader="isLoading">
  <hs-panel-card
    class="d-flex flex-column w-100 h-100"
    header="No Exception Found"
    *ngIf="!exception"
  >
    <p>No exception was found for this job</p>
  </hs-panel-card>

  <textarea readonly class="form-control" rows="5" *ngIf="exception">
  {{ exception }}
  </textarea>
</div>
